import "./whatsapp-connected-success.css";

// Reused from donor c3ca36a4's shared passive partial: 3 × 20 finite particles.
// WHY [BOL-WA-CONNECTED-812]: this component never reads a timer, QR or provider;
// its caller alone owns the receipt. A stable attempt key prevents poll replay.
export function WhatsAppConnectedSuccess() {
  return <section className="ops-wa-connected-celebration" role="status" aria-live="polite" aria-atomic="true">
    <div className="ops-wa-connected-art" aria-hidden="true">
      <div className="ops-wa-connected-confetti">{[0, 1, 2].map(burst =>
        <div className="ops-wa-connected-burst" key={burst}>{Array.from({ length: 20 }, (_, particle) =>
          <i key={particle}><b /></i>)}</div>)}</div>
      <div className="ops-wa-connected-seal">
        <svg viewBox="0 0 100 100" focusable="false"><path d="M25 51 43 69 77 33" /></svg>
      </div>
    </div>
    <h1 className="ops-wa-connected-title">Congratulations!</h1>
    <p className="ops-wa-connected-message">Your WhatsApp is connected to Ops.</p>
  </section>;
}

